/* eslint-disable @typescript-eslint/no-explicit-any */
import { EImportSectionsTarget } from '@constants';
import { ISection } from '@sdk/contracts';
import { Flex } from 'antd';
import { ReactNode } from 'react';

import { ImportActivity } from '../SectionManagement';

import { Actions } from './Actions';
import { ActivityListItem } from './ActivityListItem';
import { NewActivity } from './NewActivity';

import { SortableProvider } from '@/components/SortableProvider';
import { useLocalCourse, useProfile } from '@/store';

type Props = {
  section: ISection;
  fetchOnlyParentsCourses?: boolean;
};

export const Activities: React.FC<Props> = ({ section, fetchOnlyParentsCourses }) => {
  const { course, reorderCourseActivities } = useLocalCourse();
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!course) return null;

  const { sections } = course;
  const { parentSection } = section;
  const activities = sections.find(s => s._id === section._id)?.activities || [];

  const handleReorder = (items: ReactNode[]) => {
    const newActivitiesOrder = items.map(item => (item as any).props._id);
    reorderCourseActivities({ courseId: course._id, sectionId: section._id, newActivitiesOrder });
  };

  return (
    <div>
      {isManager && !parentSection && <Actions sectionId={section._id} activities={activities} />}
      <SortableProvider
        onReorder={handleReorder}
        zIndex={20}
        droppableId="activities"
        isDragDisabled={!isManager}>
        {activities.map(activity => (
          <ActivityListItem
            {...activity}
            key={activity._id}
            course={course}
            section={section}
            activity={activity}
          />
        ))}
      </SortableProvider>

      {isManager && !parentSection && (
        <Flex gap={16} style={{ marginTop: 16, marginLeft: 36 }}>
          <NewActivity course={course} sectionId={section._id} />
          <ImportActivity
            courseId={course._id}
            sectionId={section._id}
            target={EImportSectionsTarget.SECTIONS}
            fetchOnlyParentsCourses={fetchOnlyParentsCourses}
          />
        </Flex>
      )}
    </div>
  );
};
